import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { Icon, ChevronRightIcon } from 'components/shared/Icon/Icon'

import { AccordionContext } from './../../context'

import styles from './Header.module.scss'

type HeaderProps = {
  buttonClassName?: string
  className?: string
  title?: React.ReactNode
  children?: React.ReactNode
  wrapperClassName?: string
  onToggle?: () => void
}

export const Header = ({
  buttonClassName,
  className,
  title,
  children,
  wrapperClassName,
  onToggle,
}: HeaderProps) => {
  const { handleToggle, isDisabled, isOpen } =
    React.useContext(AccordionContext)

  return (
    <Box align="center" className={cx(styles.header, className)}>
      <button
        className={cx(styles.button, buttonClassName)}
        disabled={isDisabled}
        {...(!isDisabled && {
          onClick: onToggle ? onToggle : handleToggle,
        })}
      >
        <Box
          align="center"
          className={cx(styles.wrapper, wrapperClassName)}
          tagName="span"
        >
          <Icon
            className={cx(styles.chevron, { [styles.opened]: isOpen })}
            icon={ChevronRightIcon}
            size={24}
          />
          {title}
        </Box>
      </button>
      {children}
    </Box>
  )
}
